import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { BrandLockup } from "../components/app/Logo";
import { BackButton } from "../components/app/BackButton";
import { PasswordInput } from "../components/app/PasswordInput";
import { useI18n } from "../lib/i18n";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useI18n();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!token) { toast.error(t("reset_invalid")); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success(t("reset_success"));
      navigate("/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || t("reset_invalid"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col" data-testid="reset-page">
      <div className="border-b border-white/10">
        <div className="mx-auto max-w-7xl px-6 md:px-8 h-14 flex items-center justify-between">
          <Link to="/"><BrandLockup /></Link>
          <BackButton fallback="/login" />
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md surface-card p-8">
          <span className="label-mono">PASSWORD // UPDATE</span>
          <h1 className="mt-3 text-2xl font-semibold tracking-tight">{t("reset_title")}</h1>

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div className="space-y-2">
              <Label className="label-mono">{t("field_password")}</Label>
              <PasswordInput required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
                placeholder={t("placeholder_password_signup")}
                className="bg-[#0e0e0e] border-white/10 rounded-none h-11 font-mono focus-visible:ring-bull/40 focus-visible:border-bull/40"
                data-testid="reset-password-input" />
            </div>
            <Button type="submit" disabled={busy || !token} className="w-full rounded-none bg-white text-black hover:bg-neutral-200 h-11 font-medium" data-testid="reset-submit-btn">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : t("reset_submit")}
            </Button>
            {!token && <p className="text-xs text-bear font-mono">{t("reset_invalid")}</p>}
          </form>
        </div>
      </div>
    </div>
  );
}
